export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_IS_AUTH = 'SET_IS_AUTH';
export const UPDATE_SESSION = 'UPDATE_SESSION';